var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-editor-components-panel"},[_c('components',{attrs:{"initialized":_vm.initialized}}),_c('add-component',{attrs:{"title":"Add component","components":_vm.addElements}}),_c('add-component',{attrs:{"title":"Saved components","components":_vm.customComponents,"custom":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }